import React from 'react'

function Navbar() {
  return (
    <navbar className="nav nav-bar">
        <div className="logo">
            <a href="#">Todo<span>App</span></a>
        </div>
    </navbar>
  )
}

export default Navbar